import { Link } from 'react-router-dom';

/**
 * Table of students with missing profile fields and edit links.
 */
export default function CompletenessStudentTable({ items, loading }) {
  if (loading) {
    return <p className="text-sm theme-text-secondary">Loading students…</p>;
  }

  if (!items?.length) {
    return (
      <p className="text-sm theme-text-secondary">
        No students match this completeness filter.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto rounded-lg border" style={{ borderColor: 'var(--color-border)' }}>
      <table className="w-full theme-table text-sm">
        <thead>
          <tr>
            <th className="text-left p-3">Name</th>
            <th className="text-left p-3">Email</th>
            <th className="text-left p-3">VE ID</th>
            <th className="text-left p-3">Missing</th>
            <th className="text-right p-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((student) => (
            <tr key={student.id}>
              <td className="p-3 theme-text">{student.fullName}</td>
              <td className="p-3 theme-text-secondary">{student.emailAddress}</td>
              <td className="p-3 theme-text-secondary">{student.id}</td>
              <td className="p-3">
                {student.complete ? (
                  <span className="text-xs theme-text-secondary">Complete</span>
                ) : (
                  <span className="text-xs theme-text" title={student.missingLabels?.join(', ')}>
                    {student.missingCount} field
                    {student.missingCount === 1 ? '' : 's'}
                    {student.missingLabels?.length
                      ? `: ${student.missingLabels.slice(0, 4).join(', ')}${
                          student.missingLabels.length > 4 ? '…' : ''
                        }`
                      : ''}
                  </span>
                )}
              </td>
              <td className="p-3 text-right">
                <Link
                  to={`/admin/edit-user?email=${encodeURIComponent(student.emailAddress)}`}
                  className="text-sm underline theme-text"
                >
                  Complete details
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
